export default __webpack_public_path__ + "static/media/pic.024e8adc.JPG";